
import { connect } from 'react-redux';
import ClientDetails from './ClientDetails';
import { setProgressBarStatus } from '../../redux/actions/progressBar';

const mapStateToProps = null;

const mapDispatchToProps = {
  setProgressBarStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientDetails);
